import React from "react";
import { getPayoutMethodLabel, getStatusBadgeClass, getStatusLabel } from "./utils";

export default function SavedMethodsList({
  earnings,
  startEditMethod,
  handleDeleteMethod,
  isAr,
}) {
  const { methods } = earnings;

  return (
    <div className="card border-0 shadow-sm mb-4 provider-center__panel-card pc-panel--methods">
      <div className="card-body">
        <div className="pc-section-head mb-3">
          <div className="pc-section-head__left">
            <span className="pc-icon-box pc-icon-box--purple"><i className="bi bi-credit-card-2-front" /></span>
            <h5 className="mb-0">{isAr ? "طرق السحب المحفوظة" : "Saved Payout Methods"}</h5>
          </div>
          <span className="badge text-bg-light">{methods.length}</span>
        </div>

        {methods.length === 0 ? (
          <div className="text-muted small">
            {isAr
              ? "سيظهر هنا أي حساب PayPal أو Stripe تم ربطه فعليًا."
              : "Any PayPal or Stripe account that has actually been linked appears here."}
          </div>
        ) : (
          <div className="row g-3">
            {methods.map((method) => (
              <div className="col-12 col-md-6" key={method.id}>
                <div className="border rounded-4 p-3 h-100">
                  <div className="d-flex justify-content-between align-items-start gap-3">
                    <div>
                      <div className="fw-semibold">
                        {getPayoutMethodLabel(method.method, isAr)}
                        {method.isDefault ? (
                          <span className="badge text-bg-dark ms-2">
                            {isAr ? "افتراضي" : "Default"}
                          </span>
                        ) : null}
                      </div>
                      <div className="small text-muted">
                        {method.accountLabel || method.accountName || "-"}
                      </div>
                      <div className="small text-muted mt-1">
                        {method.destinationEmail || method.destinationReference || "-"}
                      </div>
                      {method.meta?.linked_account ? (
                        <div className="small text-muted mt-1">
                          {method.method === "paypal"
                            ? isAr
                              ? "تم ربطه عبر تسجيل الدخول إلى PayPal"
                              : "Linked by signing in with PayPal"
                            : isAr
                              ? "تم ربطه عبر Stripe Connect"
                              : "Linked via Stripe Connect"}
                        </div>
                      ) : null}
                      <div className="small mt-2">
                        <span className={`badge rounded-pill ${getStatusBadgeClass(method.status)}`}>
                          {getStatusLabel(method.status, isAr)}
                        </span>
                      </div>
                    </div>

                    <div className="d-flex flex-column gap-2">
                      {!method.meta?.linked_account ? (
                        <button
                          type="button"
                          className="btn btn-outline-dark btn-sm"
                          onClick={() => startEditMethod(method)}
                        >
                          {isAr ? "تعديل" : "Edit"}
                        </button>
                      ) : null}
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => handleDeleteMethod(method)}
                      >
                        {isAr ? "حذف" : "Delete"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
